import makeStyles from '@mui/styles/makeStyles';
import * as React from 'react';
import Box from '@mui/material/Box';
import {FormControlLabel, Stack, Switch} from '@mui/material';
import FHIROutMessages from './fhir_out_messages';
import {TabPanel} from '../../components/other/tabPanel';
import AgyleHeader from '../../components/header/agyleHeader/agyleHeader';
import {isCentralPageModuleEnabled} from '../centralPage/helper';


const useStyles = makeStyles((theme) => ({
    indicator: {
        backgroundColor: "#448FFF"
    },
    switch_base: {
        "&.Mui-checked": {
            color: "#448FFF"
        },
        "&.Mui-checked + .MuiSwitch-track": {
            backgroundColor: "#448FFF",
        }
    },
}));


function FHIRDashboard({fromRoute}) {
    const [value, setValue] = React.useState(0);
    const classes = useStyles();
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const [filterHidden, setFiltersHidden] = React.useState(false);

    const handleHideFilters = (e) => {
        setFiltersHidden(e.target.checked);
        e.stopPropagation();
    }

    const [liveMessage, setLiveMessage] = React.useState(true);

    const handleLive = (e) => {
        setLiveMessage(e.target.checked);
        e.stopPropagation();
    }

    const switchVisible = () => {
        return value === 0 || value === 1;
    }
    return (<Box sx={{ width: '100%' }}>
        <AgyleHeader
            disableBack={!isCentralPageModuleEnabled}
            disableLogo={!fromRoute}
        >
            <Stack direction='row' sx={{pl: 2}}>
                {switchVisible() && (
                  <>
                      <FormControlLabel control={<Switch classes={{switchBase: classes.switch_base}} checked={filterHidden} size="small" onChange={handleHideFilters}/>} label={"Hide Filters "}/>
                      <FormControlLabel control={<Switch classes={{switchBase: classes.switch_base}} checked={liveMessage} size="small" onChange={handleLive}/>} label={"Live"}/>
                  </>
                )}
            </Stack>
        </AgyleHeader>

        <TabPanel value={value} index={0}>
            <FHIROutMessages filterHidden = {filterHidden} liveMessage={liveMessage} />
        </TabPanel>
    </Box>)
}

export default FHIRDashboard;